export default __webpack_public_path__ + "static/media/cheque-fr.aceeebd1.png";